export const nswHNStaticData = [
  {
    cardNumber: 1,
    cardHeadingNumber: 6,
    title: 'Your Novated Lease Checklist',
    prefix:
      '<p>This checklist has been prepared to assist you in understanding your obligations and key features under the proposed lease. This checklist is a requirement by your employer and you will need to complete this checklist.</p><p>If you have any questions, or need assistance to complete the checklist please contact your Maxxia representative.</p>',
    prefixPdf:
      'This checklist contains information and facts in relation to your Novated Lease proposal. It has been prepared to assist you in understanding your obligations under the proposed lease.',
    pdfText:
      'You have already accepted this checklist at the proposal stage.',
    datablocks: [
      {
        heading: 'Important Points to Look For on Your Quote',
        showIds: true,
        checklistItems: [
          {
            id: 1,
            isChecked: false,
            text: 'My Maxxia consultant has discussed with me if I am a <i>contractor or staff specialist</i>, and explained how this affects my novated lease quote.',
          },
          {
            id: 2,
            isChecked: false,
            text: 'The FBT base value is clearly shown on the quote.',
          },
          {
            id: 3,
            isChecked: false,
            text: 'The term of the lease is clearly stated, and I have considered if the term is right for my circumstances (e.g. I am not planning to cease employment within the term of the lease).',
          },
          {
            id: 4,
            isChecked: false,
            text: 'I understand the options available at the end of the lease.',
          },
          {
            id: 5,
            isChecked: false,
            text: 'The kilometre estimate on which all running cost budgets are calculated is clearly stated.',
          },
          {
            id: 6,
            isChecked: false,
            text: 'It is clear from the quote how running costs such as maintenance and repairs, tyres and fuels are budgeted for.',
          },
          {
            id: 7,
            isChecked: false,
            text: 'All inclusions such as accessories and insurances clearly stated and as agreed to.',
          },
          {
            id: 8,
            isChecked: false,
            text: 'I am aware that I can Salary Package a novated lease fully/partially inside the cap using pre-tax deductions, or make post-tax contributions (employee contribution method) towards the taxable value of the lease.',
          },
          {
            id: 9,
            isChecked: false,
            text: 'I am aware of how the share of savings will be applied to my lease.',
          },
          {
            id: 10,
            isChecked: false,
            text: 'Any optional insurances have been clearly explained and I am aware of the impact on your vehicle finance amount.',
          },
          {
            id: 11,
            isChecked: false,
            text: 'I have been provided with the Terms and Conditions and the Product Disclosure Statements.',
          },
          {
            id: 12,
            isChecked: false,
            text: 'I am aware that I can source my own insurance and roadside assistance.',
          },
          {
            id: 13,
            isChecked: false,
            text: 'The residual value is calculated in accordance with ATO guidelines.',
          },
          {
            id: 14,
            isChecked: false,
            text: 'I am aware that I can obtain quotes from one of the following panel of approved novated leasing providers. Maxxia, Smart Salary or LeasePlus.',
          },
          {
            id: 15,
            isChecked: false,
            text: 'I understand the financial commitment of the proposed lease.<br/><b>It is strongly recommended to obtain independent financial advice.</b>',
          },
          {
            id: 16,
            isChecked: false,
            text: 'I am aware that income tax deductions cannot be claimed for a novated lease for any "business use".',
          }
        ]
      }
    ]
  },
  {
    cardNumber: 2,
    cardHeadingNumber: 7,
    title: 'Your Maxxia Authorisation',
    prefix:
      '<p>This checklist has been prepared to assist you in understanding your obligations and key features under the proposed lease. You will need to complete this checklist.</p><p>If you have any questions, or need assistance to complete the checklist please contact your Maxxia representative.</p>',
    prefixPdf:
      'This checklist contains information and facts in relation to your Novated Lease proposal. It has been prepared to assist you in understanding your obligations under the proposed lease.',
    pdfText:
      'You have already accepted this checklist, at the proposal stage in consultation with a Maxxia representative.',
    datablocks: [
      {
        heading: 'I have read and agree that:',
        showIds: true,
        checklistItems: [
          {
            id: 1,
            isChecked: false,
            text: 'This is the lease I have discussed with my consultant, and I’m happy to proceed.',
          },
          {
            id: 2,
            isChecked: false,
            text: 'I acknowledge that the prices and rates specified above may be subject to change by the manufacturer or relavent authorities before delivery.',
          },
          {
            id: 3,
            isChecked: false,
            text: 'I acknowledge that Maxxia may receive commissions or rebates and retain interest earned on moneys held in connection with some services it provides or arranges to be provided by third Parties.',
          },
          {
            id: 4,
            isChecked: false,
            text: 'I understand that the lease insurances are add-on, and that I won’t be able to add them once my lease has begun. Before making a decision on these products I have read the Product Disclosure Statements.',
          }
        ]
      }
    ]
  }
]
